import React from "react";
import { auth } from "../auth";
import { redirect } from "next/navigation";
import { getConfig } from "../config";

type Props = {
  redirectUrl?: string;
  children: React.ReactNode;
};

export async function SignIn(props: Props) {
  const user = await auth();
  const config = getConfig();

  if (!user) redirect(props.redirectUrl || config.signInUrl);

  return props.children;
}
